/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AgentTest } from '../model';
// @ts-ignore
import type { AgentTestDefinitionChange } from '../model';
// @ts-ignore
import type { AgentTestPaginated } from '../model';
// @ts-ignore
import type { AgentTestRun } from '../model';
// @ts-ignore
import type { AgentTestRunPaginated } from '../model';
// @ts-ignore
import type { AgentTestRunSorting } from '../model';
// @ts-ignore
import type { AgentTestSorting } from '../model';
// @ts-ignore
import type { CreateAgentTestRequest } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { UpdateAgentTestRequest } from '../model';
/**
 * AgentTestApi - axios parameter creator
 */
export const AgentTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Agent Test
         * @param {string} projectId 
         * @param {CreateAgentTestRequest} createAgentTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentTest: async (projectId: string, createAgentTestRequest: CreateAgentTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createAgentTest', 'projectId', projectId)
            // verify required parameter 'createAgentTestRequest' is not null or undefined
            assertParamExists('createAgentTest', 'createAgentTestRequest', createAgentTestRequest)
            const localVarPath = `/agent-tests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAgentTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete the agent test. Its runs are never deleted.
         * @summary Delete Agent Test
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentTest: async (agentTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentTestId' is not null or undefined
            assertParamExists('deleteAgentTest', 'agentTestId', agentTestId)
            const localVarPath = `/agent-tests/{agent_test_id}`
                .replace('{agent_test_id}', encodeURIComponent(String(agentTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Agent Test
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTest: async (agentTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentTestId' is not null or undefined
            assertParamExists('getAgentTest', 'agentTestId', agentTestId)
            const localVarPath = `/agent-tests/{agent_test_id}`
                .replace('{agent_test_id}', encodeURIComponent(String(agentTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Field-level change log of the definition, newest first.
         * @summary Get Agent Test Definition Changes
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTestDefinitionChanges: async (agentTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentTestId' is not null or undefined
            assertParamExists('getAgentTestDefinitionChanges', 'agentTestId', agentTestId)
            const localVarPath = `/agent-tests/{agent_test_id}/definition-changes`
                .replace('{agent_test_id}', encodeURIComponent(String(agentTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run history for an agent test, newest first. Runs are immutable.  Phase 2 (story 2.7) extends this to soft-deleted tests, whose runs must stay queryable; today the path resolves through `get_agent_test_dep`, which excludes them.
         * @summary Get Agent Test Runs
         * @param {string} agentTestId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AgentTestRunSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTestRuns: async (agentTestId: string, page?: number, size?: number, sortBy?: AgentTestRunSorting | null, descending?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentTestId' is not null or undefined
            assertParamExists('getAgentTestRuns', 'agentTestId', agentTestId)
            const localVarPath = `/agent-tests/{agent_test_id}/runs`
                .replace('{agent_test_id}', encodeURIComponent(String(agentTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the project\'s agent tests. Soft-deleted tests are excluded.
         * @summary Get Agent Tests
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AgentTestSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [exactMatch] 
         * @param {boolean | null} [enabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTests: async (projectId: string, page?: number, size?: number, sortBy?: AgentTestSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, exactMatch?: boolean, enabled?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getAgentTests', 'projectId', projectId)
            const localVarPath = `/agent-tests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger the agent test now and answer with the pending run.  The response does not wait for the agent: the run is created ``pending``, handed to the agent service, and returned. Its verdict arrives later, on the run record.
         * @summary Run Agent Test
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAgentTest: async (agentTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentTestId' is not null or undefined
            assertParamExists('runAgentTest', 'agentTestId', agentTestId)
            const localVarPath = `/agent-tests/{agent_test_id}/runs`
                .replace('{agent_test_id}', encodeURIComponent(String(agentTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Agent Test
         * @param {string} agentTestId 
         * @param {UpdateAgentTestRequest} updateAgentTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentTest: async (agentTestId: string, updateAgentTestRequest: UpdateAgentTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentTestId' is not null or undefined
            assertParamExists('updateAgentTest', 'agentTestId', agentTestId)
            // verify required parameter 'updateAgentTestRequest' is not null or undefined
            assertParamExists('updateAgentTest', 'updateAgentTestRequest', updateAgentTestRequest)
            const localVarPath = `/agent-tests/{agent_test_id}`
                .replace('{agent_test_id}', encodeURIComponent(String(agentTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgentTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentTestApi - functional programming interface
 */
export const AgentTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Agent Test
         * @param {string} projectId 
         * @param {CreateAgentTestRequest} createAgentTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentTest(projectId: string, createAgentTestRequest: CreateAgentTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentTest(projectId, createAgentTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.createAgentTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete the agent test. Its runs are never deleted.
         * @summary Delete Agent Test
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentTest(agentTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentTest(agentTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.deleteAgentTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Agent Test
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTest(agentTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTest(agentTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.getAgentTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Field-level change log of the definition, newest first.
         * @summary Get Agent Test Definition Changes
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTestDefinitionChanges(agentTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentTestDefinitionChange>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTestDefinitionChanges(agentTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.getAgentTestDefinitionChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run history for an agent test, newest first. Runs are immutable.  Phase 2 (story 2.7) extends this to soft-deleted tests, whose runs must stay queryable; today the path resolves through `get_agent_test_dep`, which excludes them.
         * @summary Get Agent Test Runs
         * @param {string} agentTestId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AgentTestRunSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTestRuns(agentTestId: string, page?: number, size?: number, sortBy?: AgentTestRunSorting | null, descending?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTestRunPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTestRuns(agentTestId, page, size, sortBy, descending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.getAgentTestRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the project\'s agent tests. Soft-deleted tests are excluded.
         * @summary Get Agent Tests
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AgentTestSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [exactMatch] 
         * @param {boolean | null} [enabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTests(projectId: string, page?: number, size?: number, sortBy?: AgentTestSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, exactMatch?: boolean, enabled?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTestPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTests(projectId, page, size, sortBy, descending, nameOrUniqueCode, exactMatch, enabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.getAgentTests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger the agent test now and answer with the pending run.  The response does not wait for the agent: the run is created ``pending``, handed to the agent service, and returned. Its verdict arrives later, on the run record.
         * @summary Run Agent Test
         * @param {string} agentTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runAgentTest(agentTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTestRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runAgentTest(agentTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.runAgentTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Agent Test
         * @param {string} agentTestId 
         * @param {UpdateAgentTestRequest} updateAgentTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentTest(agentTestId: string, updateAgentTestRequest: UpdateAgentTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentTest(agentTestId, updateAgentTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentTestApi.updateAgentTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentTestApi - factory interface
 */
export const AgentTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentTestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Agent Test
         * @param {AgentTestApiCreateAgentTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentTest(requestParameters: AgentTestApiCreateAgentTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentTest> {
            return localVarFp.createAgentTest(requestParameters.projectId, requestParameters.createAgentTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete the agent test. Its runs are never deleted.
         * @summary Delete Agent Test
         * @param {AgentTestApiDeleteAgentTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentTest(requestParameters: AgentTestApiDeleteAgentTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAgentTest(requestParameters.agentTestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Agent Test
         * @param {AgentTestApiGetAgentTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTest(requestParameters: AgentTestApiGetAgentTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentTest> {
            return localVarFp.getAgentTest(requestParameters.agentTestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Field-level change log of the definition, newest first.
         * @summary Get Agent Test Definition Changes
         * @param {AgentTestApiGetAgentTestDefinitionChangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTestDefinitionChanges(requestParameters: AgentTestApiGetAgentTestDefinitionChangesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentTestDefinitionChange>> {
            return localVarFp.getAgentTestDefinitionChanges(requestParameters.agentTestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Run history for an agent test, newest first. Runs are immutable.  Phase 2 (story 2.7) extends this to soft-deleted tests, whose runs must stay queryable; today the path resolves through `get_agent_test_dep`, which excludes them.
         * @summary Get Agent Test Runs
         * @param {AgentTestApiGetAgentTestRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTestRuns(requestParameters: AgentTestApiGetAgentTestRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentTestRunPaginated> {
            return localVarFp.getAgentTestRuns(requestParameters.agentTestId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, options).then((request) => request(axios, basePath));
        },
        /**
         * List the project\'s agent tests. Soft-deleted tests are excluded.
         * @summary Get Agent Tests
         * @param {AgentTestApiGetAgentTestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTests(requestParameters: AgentTestApiGetAgentTestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentTestPaginated> {
            return localVarFp.getAgentTests(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.exactMatch, requestParameters.enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger the agent test now and answer with the pending run.  The response does not wait for the agent: the run is created ``pending``, handed to the agent service, and returned. Its verdict arrives later, on the run record.
         * @summary Run Agent Test
         * @param {AgentTestApiRunAgentTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runAgentTest(requestParameters: AgentTestApiRunAgentTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentTestRun> {
            return localVarFp.runAgentTest(requestParameters.agentTestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Agent Test
         * @param {AgentTestApiUpdateAgentTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentTest(requestParameters: AgentTestApiUpdateAgentTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentTest> {
            return localVarFp.updateAgentTest(requestParameters.agentTestId, requestParameters.updateAgentTestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAgentTest operation in AgentTestApi.
 */
export interface AgentTestApiCreateAgentTestRequest {
    readonly projectId: string

    readonly createAgentTestRequest: CreateAgentTestRequest
}

/**
 * Request parameters for deleteAgentTest operation in AgentTestApi.
 */
export interface AgentTestApiDeleteAgentTestRequest {
    readonly agentTestId: string
}

/**
 * Request parameters for getAgentTest operation in AgentTestApi.
 */
export interface AgentTestApiGetAgentTestRequest {
    readonly agentTestId: string
}

/**
 * Request parameters for getAgentTestDefinitionChanges operation in AgentTestApi.
 */
export interface AgentTestApiGetAgentTestDefinitionChangesRequest {
    readonly agentTestId: string
}

/**
 * Request parameters for getAgentTestRuns operation in AgentTestApi.
 */
export interface AgentTestApiGetAgentTestRunsRequest {
    readonly agentTestId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: AgentTestRunSorting | null

    readonly descending?: boolean | null
}

/**
 * Request parameters for getAgentTests operation in AgentTestApi.
 */
export interface AgentTestApiGetAgentTestsRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: AgentTestSorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly exactMatch?: boolean

    readonly enabled?: boolean | null
}

/**
 * Request parameters for runAgentTest operation in AgentTestApi.
 */
export interface AgentTestApiRunAgentTestRequest {
    readonly agentTestId: string
}

/**
 * Request parameters for updateAgentTest operation in AgentTestApi.
 */
export interface AgentTestApiUpdateAgentTestRequest {
    readonly agentTestId: string

    readonly updateAgentTestRequest: UpdateAgentTestRequest
}

/**
 * AgentTestApi - object-oriented interface
 */
export class AgentTestApi extends BaseAPI {
    /**
     * 
     * @summary Create Agent Test
     * @param {AgentTestApiCreateAgentTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAgentTest(requestParameters: AgentTestApiCreateAgentTestRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).createAgentTest(requestParameters.projectId, requestParameters.createAgentTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete the agent test. Its runs are never deleted.
     * @summary Delete Agent Test
     * @param {AgentTestApiDeleteAgentTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAgentTest(requestParameters: AgentTestApiDeleteAgentTestRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).deleteAgentTest(requestParameters.agentTestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Agent Test
     * @param {AgentTestApiGetAgentTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentTest(requestParameters: AgentTestApiGetAgentTestRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).getAgentTest(requestParameters.agentTestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Field-level change log of the definition, newest first.
     * @summary Get Agent Test Definition Changes
     * @param {AgentTestApiGetAgentTestDefinitionChangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentTestDefinitionChanges(requestParameters: AgentTestApiGetAgentTestDefinitionChangesRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).getAgentTestDefinitionChanges(requestParameters.agentTestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run history for an agent test, newest first. Runs are immutable.  Phase 2 (story 2.7) extends this to soft-deleted tests, whose runs must stay queryable; today the path resolves through `get_agent_test_dep`, which excludes them.
     * @summary Get Agent Test Runs
     * @param {AgentTestApiGetAgentTestRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentTestRuns(requestParameters: AgentTestApiGetAgentTestRunsRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).getAgentTestRuns(requestParameters.agentTestId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the project\'s agent tests. Soft-deleted tests are excluded.
     * @summary Get Agent Tests
     * @param {AgentTestApiGetAgentTestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentTests(requestParameters: AgentTestApiGetAgentTestsRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).getAgentTests(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.exactMatch, requestParameters.enabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger the agent test now and answer with the pending run.  The response does not wait for the agent: the run is created ``pending``, handed to the agent service, and returned. Its verdict arrives later, on the run record.
     * @summary Run Agent Test
     * @param {AgentTestApiRunAgentTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public runAgentTest(requestParameters: AgentTestApiRunAgentTestRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).runAgentTest(requestParameters.agentTestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Agent Test
     * @param {AgentTestApiUpdateAgentTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAgentTest(requestParameters: AgentTestApiUpdateAgentTestRequest, options?: RawAxiosRequestConfig) {
        return AgentTestApiFp(this.configuration).updateAgentTest(requestParameters.agentTestId, requestParameters.updateAgentTestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

